import { registerModuleConfigUrl, registerModuleBaseUrl, moduleConfigBaseUrlNonProd } from '@cmctechnology/webinvest-module';

const MODULES_LOCAL_STORAGE_KEY = 'modules';
const registerModuleConfigsFromQuery = () => {
  const query = new URLSearchParams(window.location.search);
  if (query.has('clearModules')) {
    window.sessionStorage.removeItem(MODULES_LOCAL_STORAGE_KEY);
  }

  const modules = query.get('modules') ?? window.sessionStorage.getItem(MODULES_LOCAL_STORAGE_KEY);
  if (!modules) {
    return;
  }

  const previousModules = window.sessionStorage.getItem(MODULES_LOCAL_STORAGE_KEY);
  if (modules !== previousModules) {
    // Clear the previous modules from local storage if they are different
    window.sessionStorage.removeItem(MODULES_LOCAL_STORAGE_KEY);
  }

  window.sessionStorage.setItem(MODULES_LOCAL_STORAGE_KEY, modules);
  const baseUrl = registerModuleBaseUrl();
  modules.split(';').forEach((module) => {
    const [appName, pr] = module.split(':');
    const url = `${baseUrl}/${appName}/v/${pr}/remoteEntry.js`;
    registerModuleConfigUrl(appName, url);
  });
};

// When running from `npm start` this will be true, see package.json script
if (process.env.REACT_APP_USE_NONPROD_MODULE_URL) {
  registerModuleBaseUrl(moduleConfigBaseUrlNonProd);
}
registerModuleConfigsFromQuery();
